window.PopupCoupon = {


    init(){


        const copyButton =
        document.getElementById(
            "MaisaCopyCoupon"
        );


        const coupon =
        document.getElementById(
            "MaisaCoupon"
        );


        const message =
        document.getElementById(
            "MaisaCopyMessage"
        );



        if(
            !copyButton ||
            !coupon
        ){

            return;

        }



        copyButton.addEventListener(
            "click",
            async ()=>{


                try{


                    await navigator.clipboard.writeText(
                        coupon.innerText.trim()
                    );



                    copyButton.innerHTML =
                    "✓ Código copiado";



                    if(message){

                        message.style.display =
                        "block";

                    }



                    setTimeout(()=>{


                        copyButton.innerHTML =
                        "📋 Copiar código";



                        if(message){

                            message.style.display =
                            "none";

                        }


                    },2000);



                }
                catch(error){


                    console.error(
                        "Error copiando cupón",
                        error
                    );


                }


            }
        );


    }


};